import React from 'react';
import { Link } from 'react-router-dom';

const LandingNav = ({ scrollToSection, featuresRef, useCasesRef, faqRef }) => (
  <nav className="landing-page-nav">
    <div className="landing-page-nav-links">
      <Link
        to={scrollToSection && featuresRef ? "#features" : "/#features"}
        className="landing-page-nav-link"
        onClick={scrollToSection && featuresRef ? () => scrollToSection(featuresRef) : undefined}
      >
        Features
      </Link>
      <Link
        to={scrollToSection && useCasesRef ? "#use-cases" : "/#use-cases"}
        className="landing-page-nav-link"
        onClick={scrollToSection && useCasesRef ? () => scrollToSection(useCasesRef) : undefined}
      >
        Use Cases
      </Link>
      <Link to="/pricing" className="landing-page-nav-link">Pricing</Link>
      <Link
        to={scrollToSection && faqRef ? "#faq" : "/#faq"}
        className="landing-page-nav-link"
        onClick={scrollToSection && faqRef ? () => scrollToSection(faqRef) : undefined}
      >
        FAQ
      </Link>
    </div>
  </nav>
);

export default LandingNav; 